<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="aut/letter-topic/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { LetterTopic } from '@/modules/aut/data/letter-topic/create'
	import { LetterTopicService } from '@/modules/aut/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return LetterTopic;
			},

			service()
			{
				return new LetterTopicService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>